import React from "react";
export default function DataProtect(){
  return(
    <>
    <section className="data-protect-area">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-5 col-md-6">
            <img src="/assets/images/data-protect-img.webp" alt="data-protect-img" />
          </div>

          <div className="col-lg-6 col-md-6">
            <div className="data-protect-content">
            <h3 className="heading">Beyond Compliance. Toward Control.</h3>
            <p>Protecting data is not just about meeting regulations. It is about ensuring <b>visibility, accountability,</b> and control across every layer of your information landscape.</p>
            <p>Dox and Box <b>enables organizations </b> to transform scattered data into structured, secure, actionable assets.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}